export const forgetpassword = {
    forgetpassword: 'Forget password',
    please_input_phone: 'Please enter your registered phone number ',
    changepassword: 'Change password',
    success: 'Create new password success'
}
